export default __webpack_public_path__ + "static/media/logInImage.523180c5.svg";